/**
 * Données livret interactif Passerelle A2 → A (7 h).
 * 5 chapitres cochés : Bienvenue · Théorie · Hors circulation · Circulation · Prêt.
 */
import { Sparkles, BookOpen, Flag, Bike, Trophy } from 'lucide-react';
import { PHASES_PASSERELLE } from './passerelleA2AProgression';

const COMPETENCES_PASSERELLE = PHASES_PASSERELLE.flatMap(p =>
  (p.exercises || []).map(ex => ({ id: ex.id, title: ex.title, phaseId: p.id }))
);

export const LIVRET_PASSERELLE_A2A = {
  storageKey: 'code2roues:livret-passerelle-a2-a:v1',
  trameKey: 'passerelle',
  competences: COMPETENCES_PASSERELLE,
  title: 'Livret Passerelle A2 → A',
  subtitle: '7 h · Accéder à la catégorie A',
  trameTo: '/passerelle-a2-a-progression',
  trameLabel: 'Trame pédagogique Passerelle A2 → A',
  livretTo: '/livret-passerelle-a2-a',
  livretLabel: 'Livret Passerelle A2 → A interactif',
  chapters: [
    {
      id: 'cover',
      n: '',
      title: 'Bienvenue dans ta passerelle A2 → A',
      icon: Sparkles,
      color: '#e11d48',
      intro: 'Ce livret t\u2019accompagne pendant tes 7 heures de passerelle A2 → A. Coche les acquis au fil des séances avec ton moniteur, ou en révision à la maison.',
      profil: true,
      sections: [
        {
          title: 'Ce que tu vas travailler',
          items: [
            'Analyser ton expérience de conducteur A2',
            'Adapter ta technique à une moto plus performante',
            'Maîtriser le freinage, le contre-braquage et l\u2019évitement',
            'Circuler en conditions réelles avec observation croisée',
            'Renforcer ton auto-évaluation et ton autonomie',
          ],
        },
      ],
    },
    {
      id: 'theorie',
      n: '01',
      title: 'Théorie · Analyser & projeter (≈ 2 h)',
      icon: BookOpen,
      color: '#0d9488',
      context: 'salle',
      sections: [
        {
          title: 'Rappels & équipements',
          items: [
            'Je connais les conditions du passage A2 → A (2 ans + 7 h)',
            'Je porte un équipement adapté à une moto plus performante',
            'J\u2019ai revu les points clés des vérifications',
          ],
        },
        {
          title: 'Retour d\u2019expérience A2',
          items: [
            'J\u2019identifie ce qui a changé depuis mon permis A2',
            'Je nomme 2 situations qui me posent encore problème',
            'Je nomme 2 points forts acquis pendant ma période A2',
            'Je définis mes objectifs pour ma passerelle',
          ],
        },
        {
          title: 'Projection catégorie A',
          items: [
            'Je comprends les différences avec une moto plus puissante',
            'J\u2019anticipe les 4 points clés des premières minutes de prise en main',
            'Je connais les accidents-types du motard expérimenté',
          ],
        },
      ],
    },
    {
      id: 'hors-circulation',
      n: '02',
      title: 'Hors circulation · Maîtriser la nouvelle moto (≈ 2 h)',
      icon: Flag,
      color: '#16a34a',
      context: 'plateau',
      sections: [
        {
          title: 'Basse vitesse',
          items: [
            'Je passe lentement en ligne droite sans caler',
            'Je réalise un huit à faible allure sans poser le pied',
            'Je réalise le gymkhana avec regard anticipé',
          ],
        },
        {
          title: 'Freinage & contre-braquage',
          items: [
            'Je vérifie mon rétrogradage sans à-coup',
            'Je freine à l\u2019urgence avec 1 puis 2 freins sans blocage',
            'Je comprends que le contre-braquage engage guidon + jambes + bassin',
            'Je réalise un slalom en gardant le regard vers la sortie',
          ],
        },
        {
          title: 'Manœuvres avancées',
          items: [
            'Je réalise une épingle à 30 km/h sans freiner en virage',
            'Je réalise un évitement sans toucher l\u2019obstacle',
          ],
        },
      ],
    },
    {
      id: 'circulation',
      n: '03',
      title: 'Circulation · Observer, analyser, conduire (≈ 3 h)',
      icon: Bike,
      color: '#ea580c',
      context: 'circulation',
      sections: [
        {
          title: 'Prise en main & roulage',
          items: [
            'J\u2019ai adapté mes repères de freinage et d\u2019accélération',
            'J\u2019ai conduit environ 1 h en conditions réelles',
            'J\u2019ai maintenu ma vigilance jusqu\u2019à la fin du tour',
          ],
        },
        {
          title: 'Observation croisée',
          items: [
            'J\u2019ai observé la conduite d\u2019un autre stagiaire',
            'J\u2019ai formulé une critique constructive (1 point fort + 1 axe)',
            'J\u2019ai participé au débriefing collectif',
          ],
        },
        {
          title: 'Correction & conduite autonome',
          items: [
            'J\u2019ai retravaillé un point faible identifié en débriefing',
            'J\u2019ai conduit environ 30 min en autonomie complète',
            'J\u2019ai formulé un plan d\u2019action après la formation',
          ],
        },
      ],
    },
    {
      id: 'pret',
      n: '04',
      title: 'Prêt pour la catégorie A ?',
      icon: Trophy,
      color: '#a855f7',
      sections: [
        {
          title: 'Auto-évaluation finale',
          items: [
            'Je me sens en sécurité sur une moto plus performante',
            'Je maîtrise mon freinage et ma trajectoire en virage',
            'Je regarde loin et j\u2019anticipe',
            'Je connais mes limites et je les respecte',
            'Je sais analyser ma propre conduite',
            'Je suis prêt à conduire une moto A en toute sécurité',
          ],
        },
      ],
    },
  ],
};
